import { forwardRef } from "react";

import Icon from "@/components/Icon";
import RawPlayIcon from "./RawPlayIcon.svg.jsx";

const PlayIcon = forwardRef((props, ref) => {
  return <Icon ref={ref} SvgComponent={RawPlayIcon} {...props} />;
});

export default PlayIcon;
